import { canv } from '@/canv/global.js'
import { toolBase } from '@/tools/toolBase';

import { IMAGE_FORMATS } from "@/constants.js";


export class moreTool extends toolBase {

    constructor() {
        super();
    }

    initView() {
        super.initView();
        var mediaInput = document.getElementsByClassName("toolBoxWrapperContentItemMediaInput")[0];

        mediaInput.removeEventListener('change', canv.appInterface.settingsWindow.placeImageProccessorHelper.bind(canv.appInterface.settingsWindow), false);
        mediaInput.addEventListener('change', canv.appInterface.settingsWindow.placeImageProccessorHelper.bind(canv.appInterface.settingsWindow), false);
    }

    getToolView() {
        return `
            <input type="file" class="toolBoxWrapperContentItemMediaInput" accept="${IMAGE_FORMATS.join(',')}" multiple style="display:none">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12H19M12 5V19" stroke="#2C2D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        `;
    }

    getToolTipName() {
        return "Больше инструментов";
    }

    select() {
        super.select();
        canv.appInterface.moreWindow.open();
    }

    unselect() {
        super.unselect();

        canv.appInterface.moreWindow.close();
        canv.appInterface.templatesWindow.close();
        canv.appInterface.stickersWindow.close();
    }


    TryAction(type) {

        if (type == "mousedown") {
            canv.toolBox.switchToByName("cursorTool");
        }

    }

    draw() { }






    name = "moreTool";
}
